<app-modal [modalSize]="'modal-medium'">
    <div class="modal-header">
      <h3 class="modal-title">Are you sure?</h3>
    </div>
  
    <div class="modal-body">
        <app-loading-spinner *ngIf="isLoading" ></app-loading-spinner>

      
      <div *ngIf="!isLoading">
        <h6 class="modal-body">
          <b>{{ userName }}</b> is currently on a list of approving members on ticketId: 
          <b><span *ngIf="requestIds.length > 0">
            {{ requestIds.join(', ') }}
          </span></b>
          <br>Do you still want to remove?
        </h6>
      </div>
    </div>
  
    <div class="modal-footer">
      <div (click)="save()" class="btn btn-primary">Confirm</div>
      <div (click)="closeModal()" class="btn btn-cancel">Cancel</div>
    </div>
</app-modal>